import { render } from "./PromotionList.vue?vue&type=template&id=4040ca48&scoped=true&ts=true"
import script from "./PromotionList.vue?vue&type=script&lang=ts"
export * from "./PromotionList.vue?vue&type=script&lang=ts"

import "./PromotionList.vue?vue&type=style&index=0&id=4040ca48&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4040ca48"]])

export default __exports__